module.exports = __webpack_public_path__ + "static/media/licenta17.b05cb280.png";